export const normalizeAssemblyChangeLogValue = (value) => {
  if (value === null || value === undefined) return '';
  return String(value).trim();
};

export const buildAssemblyChangeLogEntry = ({
  projectId,
  jobNumber,
  jobName,
  currentUser,
  userRole,
  field,
  previousValue,
  newValue,
  dateTime = new Date().toISOString(),
}) => ({
  ProjectID: projectId,
  JobNumber: jobNumber || '',
  JobName: jobName || '',
  CurrentUser: currentUser || 'Unknown',
  UserRole: userRole || 'User',
  Field: field,
  PrevValue: normalizeAssemblyChangeLogValue(previousValue),
  NewValue: normalizeAssemblyChangeLogValue(newValue),
  DateTime: dateTime,
});

export const normalizeAssemblyChangeLogs = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.value)) return payload.value;
  if (Array.isArray(payload?.data)) return payload.data;
  if (payload?.data && typeof payload.data === 'object') return Object.values(payload.data);
  return [];
};

export const formatAssemblyChangeLogValue = (value) => {
  if (value === null || value === undefined || value === '') return 'BLANK';
  if (value === false || value === 'false' || value === 'Off' || value === 'No') return 'No';
  if (value === true || value === 'true' || value === 'On' || value === 'Yes') return 'Yes';
  return value;
};

export const formatAssemblyChangeLogField = (field) => {
  if (!field) return '';
  return String(field)
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .replace(/^[a-z]/, (match) => match.toUpperCase());
};

export const formatAssemblyIssueStatusAuditValue = ({
  commentId,
  status,
  description,
}) => {
  const identity = commentId === null || commentId === undefined || commentId === ''
    ? 'Issue/comment'
    : `Issue/comment #${commentId}`;
  const normalizedStatus = normalizeAssemblyChangeLogValue(status) || 'BLANK';
  const normalizedDescription = normalizeAssemblyChangeLogValue(description);
  return `${identity}: ${normalizedStatus}${normalizedDescription ? ` — ${normalizedDescription}` : ''}`;
};

export const getSortedUniqueValues = (items, selector) => (
  [...new Set(items.map(selector).filter((value) => value !== null && value !== undefined && value !== ''))]
    .sort((left, right) => String(left).localeCompare(String(right), undefined, { sensitivity: 'base' }))
);
